export default __webpack_public_path__ + "static/media/G pay.538e5856.svg";